import script from "./TableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=ed47f0e2&lang=css"

const __exports__ = script;

export default __exports__